var _rect, _path, _path2, _path3, _path4, _path5, _path6, _rect2, _path7, _path8, _g, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListArrowIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 53,
    viewBox: "0 0 50 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 53,
    fill: "#F8F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-2496 -17148C-2496 -17201 -2453.02 -17244 -2400 -17244H14542C14595 -17244 14638 -17201 14638 -17148V11746C14638 11799 14595 11842 14542 11842H-2400C-2453.02 11842 -2496 11799 -2496 11746V-17148Z",
    fill: "#EEF6FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-2400 -17229H14542V-17259H-2400V-17229ZM14623 -17148V11746H14653V-17148H14623ZM14542 11827H-2400V11857H14542V11827ZM-2481 11746V-17148H-2511V11746H-2481ZM-2400 11827C-2444.74 11827 -2481 11790.7 -2481 11746H-2511C-2511 11807.3 -2461.3 11857 -2400 11857V11827ZM14623 11746C14623 11790.7 14586.7 11827 14542 11827V11857C14603.3 11857 14653 11807.3 14653 11746H14623ZM14542 -17229C14586.7 -17229 14623 -17192.7 14623 -17148H14653C14653 -17209.3 14603.3 -17259 14542 -17259V-17229ZM-2400 -17259C-2461.3 -17259 -2511 -17209.3 -2511 -17148H-2481C-2481 -17192.7 -2444.74 -17229 -2400 -17229V-17259Z",
    fill: "#5DA5D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-266 -246C-266 -281.346 -237.346 -310 -202 -310H4013C4048.35 -310 4077 -281.346 4077 -246V9298C4077 9333.35 4048.35 9362 4013 9362H-202C-237.346 9362 -266 9333.35 -266 9298V-246Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-202 -300H4013V-320H-202V-300ZM4067 -246V9298H4087V-246H4067ZM4013 9352H-202V9372H4013V9352ZM-256 9298V-246H-276V9298H-256ZM-202 9352C-231.823 9352 -256 9327.82 -256 9298H-276C-276 9338.87 -242.869 9372 -202 9372V9352ZM4067 9298C4067 9327.82 4042.82 9352 4013 9352V9372C4053.87 9372 4087 9338.87 4087 9298H4067ZM4013 -300C4042.82 -300 4067 -275.823 4067 -246H4087C4087 -286.869 4053.87 -320 4013 -320V-300ZM-202 -320C-242.869 -320 -276 -286.869 -276 -246H-256C-256 -275.823 -231.823 -300 -202 -300V-320Z",
    fill: "#5DA5D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-166 -146C-166 -181.346 -137.346 -210 -102 -210H1767C1802.35 -210 1831 -181.346 1831 -146V3374C1831 3409.35 1802.35 3438 1767 3438H-102C-137.346 3438 -166 3409.35 -166 3374V-146Z",
    fill: "#F5FBF9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-102 -209H1767V-211H-102V-209ZM1830 -146V3374H1832V-146H1830ZM1767 3437H-102V3439H1767V3437ZM-165 3374V-146H-167V3374H-165ZM-102 3437C-136.794 3437 -165 3408.79 -165 3374H-167C-167 3409.9 -137.899 3439 -102 3439V3437ZM1830 3374C1830 3408.79 1801.79 3437 1767 3437V3439C1802.9 3439 1832 3409.9 1832 3374H1830ZM1767 -209C1801.79 -209 1830 -180.794 1830 -146H1832C1832 -181.899 1802.9 -211 1767 -211V-209ZM-102 -211C-137.899 -211 -167 -181.899 -167 -146H-165C-165 -180.794 -136.794 -209 -102 -209V-211Z",
    fill: "black",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 2276.3,
    transform: "translate(-66 -110)",
    fill: "url(#paint0_linear_378_44749)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M-66 -78C-66 -95.6731 -51.6731 -110 -34 -110H1182C1199.67 -110 1214 -95.6731 1214 -78V2134.3C1214 2151.97 1199.67 2166.3 1182 2166.3H-34C-51.6731 2166.3 -66 2151.97 -66 2134.3V-78Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M-66 -78C-66 -95.6731 -51.6731 -110 -34 -110H1182C1199.67 -110 1214 -95.6731 1214 -78V2134.3C1214 2151.97 1199.67 2166.3 1182 2166.3H-34C-51.6731 2166.3 -66 2151.97 -66 2134.3V-78Z",
    fill: "url(#paint1_linear_378_44749)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_378_44749)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 70,
    transform: "translate(-26 -10)",
    fill: "#284993"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M0 6.29758C0 4.11772 1.76713 2.35059 3.94699 2.35059H38.8443C41.0242 2.35059 42.7913 4.11772 42.7913 6.29758V48.1896C42.7913 50.3695 41.0242 52.1366 38.8443 52.1366H3.947C1.76714 52.1366 0 50.3695 0 48.1896V6.29758Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5723,
    y: 20.3564,
    width: 18.5837,
    height: 2.13795,
    rx: 0.657832,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.38867,
    y: 9.66699,
    width: 32.5627,
    height: 4.60482,
    rx: 0.657832,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.209,
    y: 42.0654,
    width: 10.8542,
    height: 2.13795,
    rx: 0.657832,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5723,
    y: 27.5928,
    width: 18.5837,
    height: 2.13795,
    rx: 0.657832,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5723,
    y: 34.8291,
    width: 18.5837,
    height: 2.13795,
    rx: 0.657832,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 8.43028,
    y: 19.2877,
    width: 4.27591,
    height: 4.27591,
    rx: 0.246687,
    stroke: "white",
    strokeWidth: 0.493374
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 8.43028,
    y: 27.0172,
    width: 4.27591,
    height: 4.27591,
    rx: 0.246687,
    stroke: "white",
    strokeWidth: 0.493374
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 8.43028,
    y: 33.7604,
    width: 4.27591,
    height: 4.27591,
    rx: 0.246687,
    stroke: "white",
    strokeWidth: 0.493374
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6655 21.0719C10.5115 20.8898 10.2391 20.867 10.057 21.0209C9.87492 21.1749 9.85211 21.4473 10.0061 21.6294L11.1907 23.0306C11.3447 23.2127 11.6171 23.2355 11.7992 23.0816C11.9813 22.9276 12.0041 22.6552 11.8501 22.4731L10.6655 21.0719Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1133 19.54L14.1382 19.565C14.4617 19.8884 14.4617 20.4128 14.1382 20.7363L11.8149 23.0596C11.6463 23.2282 11.3729 23.2282 11.2043 23.0596C11.0357 22.891 11.0357 22.6176 11.2043 22.449L14.1133 19.54Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6655 28.3082C10.5115 28.1261 10.2391 28.1033 10.057 28.2573C9.87492 28.4112 9.85211 28.6836 10.0061 28.8657L11.1907 30.267C11.3447 30.4491 11.6171 30.4719 11.7992 30.3179C11.9813 30.164 12.0041 29.8916 11.8501 29.7095L10.6655 28.3082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1152 26.7783L14.1402 26.8033C14.4636 27.1267 14.4636 27.6511 14.1402 27.9745L11.8168 30.2979C11.6482 30.4665 11.3749 30.4665 11.2063 30.2979C11.0377 30.1293 11.0377 29.8559 11.2063 29.6873L14.1152 26.7783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7831 32.3477C36.4367 32.4405 36.1198 32.1236 36.2126 31.7772L39.558 19.2918C39.6508 18.9455 40.0838 18.8295 40.3373 19.083L49.4773 28.223C49.7308 28.4765 49.6148 28.9095 49.2685 29.0023L36.7831 32.3477Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.418,
    y: 26.6211,
    width: 3.50532,
    height: 7.19512,
    rx: 0.465782,
    transform: "rotate(-135 44.418 26.6211)",
    fill: "white"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M-25.5 -2.00001C-25.5 -6.14215 -22.1421 -9.5 -18 -9.5H1166C1170.14 -9.5 1173.5 -6.14214 1173.5 -2V407C1173.5 411.142 1170.14 414.5 1166 414.5H-18C-22.1421 414.5 -25.5 411.142 -25.5 407V-2.00001Z",
    stroke: "#284993"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_378_44749",
    x1: 640,
    y1: 0,
    x2: 640,
    y2: 1424.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_378_44749",
    x1: 574,
    y1: -110,
    x2: 574,
    y2: 1314.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_378_44749"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-26 -2.00001C-26 -6.41829 -22.4183 -10 -18 -10H1166C1170.42 -10 1174 -6.41828 1174 -2V407C1174 411.418 1170.42 415 1166 415H-18C-22.4183 415 -26 411.418 -26 407V-2.00001Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListArrowIcon);
export default __webpack_public_path__ + "static/media/ListArrowIcon.0f86e54a29693df6c171ea4391faae71.svg";
export { ForwardRef as ReactComponent };